module.exports = __webpack_public_path__ + "static/media/logo.56dccfbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/logo.png
// module id = 599
// module chunks = 0